var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4221_2447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4322 0.888672C34.5258 0.888672 35.5747 1.32311 36.348 2.0964C37.1213 2.8697 37.5557 3.91852 37.5557 5.01213V33.8763C37.5557 34.9699 37.1213 36.0188 36.348 36.7921C35.5747 37.5653 34.5258 37.9998 33.4322 37.9998H4.56804C3.47443 37.9998 2.42561 37.5653 1.65231 36.7921C0.879014 36.0188 0.44458 34.9699 0.44458 33.8763V5.01213C0.44458 3.91852 0.879014 2.8697 1.65231 2.0964C2.42561 1.32311 3.47443 0.888672 4.56804 0.888672H33.4322ZM32.4014 32.8455V21.9183C32.4014 20.1357 31.6932 18.4261 30.4328 17.1657C29.1723 15.9052 27.4627 15.1971 25.6801 15.1971C23.9277 15.1971 21.8866 16.2692 20.8969 17.8773V15.5888H15.1447V32.8455H20.8969V22.6811C20.8969 21.0936 22.1752 19.7947 23.7627 19.7947C24.5283 19.7947 25.2624 20.0988 25.8037 20.6401C26.345 21.1814 26.6491 21.9156 26.6491 22.6811V32.8455H32.4014ZM8.44409 12.3519C9.36272 12.3519 10.2437 11.987 10.8933 11.3374C11.5429 10.6878 11.9078 9.80681 11.9078 8.88818C11.9078 6.97077 10.3615 5.40386 8.44409 5.40386C7.51999 5.40386 6.63374 5.77095 5.9803 6.42439C5.32686 7.07783 4.95977 7.96408 4.95977 8.88818C4.95977 10.8056 6.52668 12.3519 8.44409 12.3519ZM11.3099 32.8455V15.5888H5.5989V32.8455H11.3099Z",
    fill: "#2D2D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4221_2447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.1111,
    height: 37.1111,
    fill: "white",
    transform: "translate(0 0.445312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.740abb19976512776b015ce5f2c57373.svg";
export { ForwardRef as ReactComponent };